import clsx from "clsx";
import { useDrawerContext } from "./drawer";
import { twMerge } from "tailwind-merge";

export interface DrawerSectionProps extends Omit<
  React.HTMLAttributes<HTMLDivElement>,
  "title"
> {
  title: React.ReactNode;
  children?: React.ReactNode;
}

export default function DrawerSection(props: Readonly<DrawerSectionProps>) {
  const { className, title, children, ...rest } = props;

  const { open, float } = useDrawerContext();

  return (
    <div
      {...rest}
      className={twMerge(
        clsx("flex flex-col", {
          "py-3 gap-1": open || float,
          "gap-2": !open && !float,
        }),
        className,
      )}
    >
      {(open || float) && <div className="px-4 truncate">{title}</div>}
      {children}
    </div>
  );
}
